export function numberToReadableString(num: number | undefined): string {
  if (num == null) return "";
  return num.toLocaleString("en-US");
}
